import React from "react";


function FilterContainer({ filterState, filterOptions, handleFilterChange }) {
    return (
        <>
            {filterState.filterOpen && (
                <div className="buff-filter-content">
                    <div className="filter-select-container">
                        {filterOptions.map((option) => (
                            <label className="filter-option" key={option.value}>
                                <input
                                    type="checkbox"
                                    value={option.value}
                                    checked={filterState.filterBy.includes(option.value)}
                                    onChange={() => handleFilterChange(option.value)}
                                />
                                {option.label}
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default FilterContainer;